<template>
    <div class="pa-4 fill-height d-flex flex-column flex-grow-1">
        <div class="activity-item">
            <h4 class="text-primary">
                <v-icon :icon="schedulerStateIcon" class="mr-1" color="primary"/>
                {{ $t('subTitle.runningProcessList') }} :

                <v-btn class="float-right" size="small" variant="text" :prepend-icon="icons.mdiContentCopy" @click="copyAllText('runningProcessListTerminal')">{{ $t('action.copyAll') }}</v-btn>
            </h4>

            <div ref="runningProcessListTerminal" id="runningProcessListTerminal" class="terminal">
                <span></span>
            </div>
        </div>

        <div class="activity-item" >
            <h4 class="text-primary">{{ $t('subTitle.processList') }} :</h4>
            <div ref="processListTerminal" id="processListTerminal" class="terminal">
                <span></span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue';
import { mdiContentCopy, mdiPlayCircleOutline, mdiStopCircleOutline, mdiHelpCircleOutline } from '@mdi/js';
import { toast } from 'vue3-toastify';
import { useLogStore } from '@/stores/logStore';

const urlWebAPI = inject('urlWebAPI');
const translate = inject('translate');
const logStore = useLogStore();

const icons = {
    mdiContentCopy,
};

const schedulerStateIcon = ref(mdiHelpCircleOutline);

const processListTerminal = ref(null);
const processListLogs = ref(null);

const runningProcessListTerminal = ref(null);
const runningProcessListLogs = ref(null);

const runningProcessListInterval = ref(null);

onMounted(() => {
    initTerminals();
    getProcessList();
    getShedulerAlive();
});

function onActivate() {
    runningProcessListInterval.value = setInterval(getRunningProcessList, 1000);
    resizeTerminals();
}

function onDeactivate() {
    clearInterval(runningProcessListInterval.value);
}

function initTerminals() {
    processListTerminal.value = $(processListTerminal.value);
    runningProcessListTerminal.value = $(runningProcessListTerminal.value);
}

function resizeTerminals() {
    runningProcessListTerminal.value.height(($('body').outerHeight(true) - $('.v-toolbar').outerHeight(true) - $('.v-card-title').outerHeight(true) - $('.v-tabs').outerHeight(true) - $('.activity-item h4').outerHeight(true) * 2 - 110) * 0.33);
    processListTerminal.value.height(($('body').outerHeight(true) - $('.v-toolbar').outerHeight(true) - $('.v-card-title').outerHeight(true) - $('.v-tabs').outerHeight(true) - $('.activity-item h4').outerHeight(true) * 2 - 110) * 0.67);
}

function writeLogs(terminal, logs) {
    let terminalText = terminal.find('span:eq(0)');
    terminalText.text('');

    logs.forEach(function (log, index) {
        let isServerTime = log.indexOf('Server time') > -1;
        let isStartDate = log.indexOf('Service start date') > -1;
        let isLastCheck = log.indexOf('Last check at') > -1;

        // LOG
        if (!isStartDate && !isLastCheck && !isServerTime) {
            let path = log.split('  ').first().match(/^.*\.\w+$/g);
            let pid = 0;

            if (path != null)
                log = log.replace(path, `<span class="log-path">${path}</span>`);

            // MANUEL EXECUTION LAUNCHED
            else if (log.indexOf('cust=') > -1) {
                path = log.split(' ').first() + ' ' + log.split(' ')[1];
                log = log.replace(path, `<span class="log-path">${path}</span>`);

                let customer = log.match(/cust=\w+/g);
                log = log.replace(customer, `<span class="log-customer">${customer}</span>`);

                let action = log.match(/action=\w+/g);
                log = log.replace(action, `<span class="log-param">${action}</span>`);

                let provider = log.match(/provider=\w+/g);
                log = log.replace(provider, `<span class="log-param">${provider}</span>`);

                let appIds = log.match(/appIds=\w+/g);
                log = log.replace(appIds, `<span class="log-param">${appIds}</span>`);

                let apps = log.match(/apps=\w+/g);
                log = log.replace(apps, `<span class="log-param">${apps}</span>`);

                let appDomainId = log.match(/appDomainId=\w+/g);
                log = log.replace(appDomainId, `<span class="log-param">${appDomainId}</span>`);

                // MATCH PID
                pid = parseInt(log.split('\t').last());

                if (!Number.isNaN(pid))
                    log = log.replace(pid, `<span class="log-pid" data-pid="${pid}">${pid} <span class="material-symbols-rounded">cancel</span></span>`);

                let dateTime = log.match(/\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2}/g);

                log = log.replace(dateTime, `<span class="log-datetime">${dateTime}</span>`);
                log = log + '<br>';
            }

            terminalText.html(terminalText.html() + log);

            if (log.indexOf('log-pid') > -1 && pid > 0)
                terminalText.find('.log-pid').click(function (e) {
                    stopRunningProcess(parseInt($(e.currentTarget).attr('data-pid')));
                });
        }

        // DATE
        else
            terminalText.html(terminalText.html() + '<span class="log-server-time">' + log + '</span>');

        if (index < logs.length - 1 && !isStartDate && !isLastCheck && !isServerTime)
            terminalText.html(terminalText.html() + '<br>');
    });
}

function getProcessList() {
    let data = {
        action: 'GetProcessList',
        reference: '',
    };

    $.getData(urlWebAPI + 'ProcessActivator', data)
        .then((logs) => {
            processListLogs.value = logs.filter(l => l != null);
            writeLogs(processListTerminal.value, processListLogs.value);
        })
        .catch(error => {
            logStore.log(error, 'error');
            toast.error('Error during executing GetProcessList.');
        });
}

function getRunningProcessList() {
    let data = {
        action: 'GetRunningProcessList',
        reference: '',
    };

    $.getData(urlWebAPI + 'ProcessActivator', data)
        .then((logs) => {
            runningProcessListLogs.value = logs.filter(l => l != null);
            writeLogs(runningProcessListTerminal.value, runningProcessListLogs.value);
        })
        .catch(error => {
            logStore.log(error, 'error');
            toast.error('Error during executing GetRunningProcessList.');
        });
}

function getShedulerAlive() {
    $.getData(urlWebAPI + 'GetShedulerAlive', {})
        .then((state) => {
            switch (state) {
                case 'Stopped':
                    schedulerStateIcon.value = mdiStopCircleOutline;
                    break;

                case 'Running':
                    schedulerStateIcon.value = mdiPlayCircleOutline;
                    break;

                case 'Unknown':
                    schedulerStateIcon.value = mdiHelpCircleOutline;
                    break;
            }
        })
        .catch(error => {
            logStore.log(error, 'error');
            toast.error('Error during executing GetShedulerAlive.');
        });
}

function stopRunningProcess(pid) {
    let data = {
        action: 'StopRunningProcess',
        pid: pid,
    };

    $.getData(urlWebAPI + 'ProcessActivator', data)
        .catch(error => {
            logStore.log(error, 'error');
            toast.error('Error during executing StopRunningProcess.');
        });
}

function copyAllText(elementRef) {
    let element = elementRef == 'runningProcessListTerminal' ? runningProcessListTerminal.value : processListTerminal.value;

    navigator.clipboard.writeText($(element).html().replace(/<br>/g, '\n\r').replace(/<\/?[^>]+(>|$)/g, ''));
    toast.info(translate('copiedInClipboard', 'action'));
}

// ViewJobs.vue calls onActivate()/onDeactivate() through a template ref — only visible
// through defineExpose() on a <script setup> component.
defineExpose({ onActivate, onDeactivate });
</script>
